export const state = {
  docCheckList: [],
  docAttached: [],
  ent_find: [],
  ent_makers: [
    { name: "ຜູ້ຕາງໜ້າ", code: "01" },
    { name: "ເຈົ້າຂອງກິດຈະການ", code: "02" },
  ],
  ent_proc: [],
  ent_paym: [],
  ent_done: [],
  inv: {

  },
  ent_detail: {
  },
  feeList: [],
  ent_status: {},
  ent_has_attorney: false,
  ent_has_application: false,
  ent_has_certificate: false,
  ent_doc_template: [],
  ent_timeline: [],
  ent_document: null,
  ent_action: [
    {
      action_code: "CREATE",
      action_type: "ຂໍໃບອະນຸຍາດ ຫຼື ຂໍໃບຢັ້ງຢືນໃໝ່",
      action_amount: 25000,
    },
    {
      action_code: "EXTEND",
      action_type: "ຂໍຕໍ່ໃບອະນຸຍາດ ຫຼື ຕໍ່ໃບຢັ້ງຢືນ",
      action_amount: 25000,
    },
    {
      action_code: "MODIFY",
      action_type: "ຂໍປ່ຽນແປງ",
      action_amount: 25000,
    },
    {
      action_code: "TERMINATE",
      action_type: "ຂໍຢຸດເຊົາ",
      action_amount: 25000,
    },
  ],
  selected_fee: [],
  selected_cate: [],
  selected_cate_parent: [],
  ent_category_select: {
    cate_id: 0,
    ent_sec_code: "",
    cate_name: "",
    cate_amount: 0,
    stt: false,
    sector: {
      ent_sec_code: "",
      ent_sec_description: "",
      stt: 0,
    },
  },
  ent_action_select: {
    action_code: "",
    action_type: "",
    action_amount: 0,
  },
  entreaty: {
    action: {
      action_code: "",
      action_type: "",
      action_amount: 0,
    },
    maker: { name: "ຜູ້ຕາງໜ້າ", code: "01" },
    categories: [],
    action_code: "",
    action_type: "",
    company_name: "",
    tin: "",
  },
  eform_application: {
    is_new: false,
    is_extend: false,
    is_modify: false,
  },
  ent_application: {
    created_at: new Date().toISOString(),
  },
  ent_attorney: {
    version_no: 1,
    g_first_name: "",
    g_surname: "",
    g_age: 0,
    g_work: "",
    g_position: "",
    g_duty: "",
    g_home_no: "",
    g_group_no: "",
    g_address_id: 1,
    g_village: "",
    g_district: "",
    g_province: "",
    g_credit_type: "",
    g_credit_no: "",
    g_credit_start: "",
    g_credit_end: "",
    g_credit_by: "",
    g_place: "",
    g_tell: "",
    g_email: "",
    r_first_name: "",
    r_surname: "",
    r_age: null,
    r_work: "",
    r_position: "",
    r_duty: "",
    r_home_no: "",
    r_group_no: "",
    r_address_id: 1,
    r_village: "",
    r_district: "",
    r_province: "",
    r_credit_type: "",
    r_credit_no: "",
    r_credit_start: "",
    r_credit_end: "",
    r_credit_by: "",
    r_tell: "",
    r_email: "",
  },
  categories: [],
  nav_menu: [
    {
      menu_name: "ໜ້າຫຼັກ",
      icon: "mdi-home",
      route: "/main",
      hasNoti: false,
      counter: 0,
    },
    {
      menu_name: "ໃບຄໍາຮ້ອງທີ່ດໍາເນີນການ",
      icon: "mdi-newspaper",
      route: "/entreaty-process",
      hasNoti: false,
      counter: 0,
    },
    {
      menu_name: "ໃບຄໍາຮ້ອງທີ່ລໍຖ້າການຊໍາລະເງິນ",
      icon: "mdi-chart-histogram",
      route: "/entreaty-payment",
      hasNoti: false,
      counter: 0,
    },
    {
      menu_name: "ໃບຄໍາຮ້ອງທີ່ສໍາເລັດ",
      icon: "mdi-folder-outline",
      route: "/ent-done",
      hasNoti: false,
      counter: 0,
    },
  ],
  nav_menu: [
    {
      menu_name: "ໜ້າຫຼັກ",
      icon: "mdi-home",
      route: "/main",
      hasNoti: false,
      counter: 0,
    },
    {
      menu_name: "ເອກະສານທີ່ກ່ຽວຂ້ອງ",
      icon: "mdi-file-arrow-up-down",
      route: "",
      hasNoti: false,
      counter: 0,
      menus: [
        {
          menu_name: "ແບບຟອມ",
          icon: "mdi-newspaper",
          route: "/business/attachments",
        },
      ]
    },
    {
      menu_name: "ໃບຄໍາຮ້ອງທີ່ດໍາເນີນການ",
      icon: "mdi-newspaper",
      route: "/entreaty-process",
      hasNoti: false,
      counter: 0,
    },
    {
      menu_name: "ໃບຄໍາຮ້ອງທີ່ລໍຖ້າການຊໍາລະເງິນ",
      icon: "mdi-chart-histogram",
      route: "/entreaty-payment",
      hasNoti: false,
      counter: 0,
    },
    {
      menu_name: "ໃບຄໍາຮ້ອງທີ່ສໍາເລັດ",
      icon: "mdi-folder-outline",
      route: "/ent-done",
      hasNoti: false,
      counter: 0,
    },
  ],
  drawer_menu: [
    {
      menu_name: "ໜ້າຫຼັກ",
      icon: "mdi-home",
      route: "/main",
      hasNoti: false,
      counter: 0,
    },
    {
      menu_name: "ໃບຄໍາຮ້ອງທີ່ດໍາເນີນການ",
      icon: "mdi-newspaper",
      route: "/entreaty-process",
      hasNoti: false,
      counter: 0,
    },
    {
      menu_name: "ໃບຄໍາຮ້ອງທີ່ລໍຖ້າການຊໍາລະເງິນ",
      icon: "mdi-chart-histogram",
      route: "/entreaty-payment",
      hasNoti: false,
      counter: 0,
    },
    {
      menu_name: "ໃບຄໍາຮ້ອງທີ່ສໍາເລັດ",
      icon: "mdi-folder-outline",
      route: "/ent-done",
      hasNoti: false,
      counter: 0,
    },
    {
      menu_name: "ປ່ຽນລະຫັດຜ່ານ",
      icon: "mdi-key",
      route: "/change-password",
      hasNoti: false,
      counter: 0,
    },
    {
      menu_name: "ອອກຈາກລະບົບ",
      icon: "mdi-logout",
      route: "",
      hasNoti: false,
      counter: 0,
      use_action: "logout",
    },
  ],
  noti_process: [],
  noti_waiting: [],
  noti_history: [],
};
